<template>
    <div>

        <!-- Signature card -->
    
        <trax-ui-card :title="cardTitle" title-bold="1" v-show="visible && launchPermission && atpDafEditStatus">

            {{ text }}

            <div class="mt-3 text-right">
                <button class="btn btn-round btn-default" @click="save()">
                    {{ lang.polaris.form.save }}
                </button>    
                <button class="btn btn-round btn-danger" @click="sign()">
                    {{ signButtonLabel }}
                </button>    
            </div>

            <!-- Signature modal -->

            <trax-ui-modal-default :id="id+'-sign'" :bus="bus" :title="lang.polaris.dashboard.signature">
                <enac-atpl-dashboard-item-save-sign-popup :id="id+'-sign'" :bus="bus" simple-text="1"></enac-atpl-dashboard-item-save-sign-popup>
            </trax-ui-modal-default>

            <!-- Toastr -->

            <trax-ui-toastr :id="id+'-toastr'" :options="toastrOptions" :labels="toastrLabels" :passed-label="toastrPassedLabel" 
                :bus="bus" v-if="!toastrDisabled">
            </trax-ui-toastr>

        </trax-ui-card>

    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'enac-procedure-atp-daf-edit'},
            atp: null,
            cardTitle: { default: lang.polaris.dashboard.save_and_sign },
            signButtonLabel: { default: lang.polaris.dashboard.save_and_sign },
            signProp: null,
            hiddenWhen: null,
            text: null,
            source: {default: 'final'},
            target: {default: '1'},
            toastrDisabled: null,
            toastrOptions: null,
            toastrLabels: null,
            toastrPassedLabel: null
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                endpoint: app_url+'polaris/api/front/procedures/'+data.procedure.id,
                endpointParams: {
                    relations: ['user', 'users']
                },
                registration: data.registration,
                visible: !this.hiddenWhen,
                bus: this.$bus
            }
        },

        computed: {

            launchPermission: function() {
                if (this.user.admin) return true;
                if (this.atp && this.user.permissions['procedure.write-atp']) return true;
                if (!this.atp && this.user.permissions['procedure.write-daf']) return true;
                var userFunction = this.user.user_function;
                if (!userFunction) return false;
                return userFunction == 'training' || userFunction == 'training_op';
            },

            atpDafEditStatus: function() {
                return this.registration.status != 'draft' && this.registration.status != 'archived';
            }
        },

        created: function() {
            this.bus.$on(this.id+'-'+this.source+'-save', this.putData);
            this.bus.$on(this.id+'-sign-created', this.signed);
            this.getData();
        },

        methods:  {

            save: function() {
                this.bus.$emit(this.id+'-'+this.target+'-save', {registration_id: this.registration.id});
            },

            sign: function() {
                this.bus.$emit(this.id+'-'+this.target+'-save', {registration_id: this.registration.id, sign: this.signProp, preflight: true});
            },

            signNow: function() {
                this.bus.$emit(this.id+'-sign-create');
            },

            signed: function() {
                this.bus.$emit(this.id+'-'+this.target+'-save', {registration_id: this.registration.id, sign: this.signProp});
            },

            getData() {
                var that = this;
                axios.get(this.endpoint, { params: this.endpointParams })
                    .then(function (response) {
                        if (that.hiddenWhen) {
                            that.visible = (response.data.data.data[that.hiddenWhen] == undefined);
                        }
                        that.bus.$emit(that.id+'-data', response.data.data);
                    })
                    .catch(function (error) {
                    });
            },
            
            putData(data) {
                var that = this;
                axios.put(this.endpoint, data)
                    .then(function (response) {
                        if (response.status == 204) return that.signNow();
                        if (data.sign) {
                            location.reload();
                        } else {
                            /*
                            if (that.hiddenWhen) {
                                that.visible = (response.data.data.data[that.hiddenWhen] == undefined);
                            }
                            */
                            that.bus.$emit(that.id+'-updated', response.data.data);
                            that.bus.$emit(that.id+'-toastr-success', response.data.data);
                        }
                    })
                    .catch(function (error) {
                        if (error.response.data.errors) {
                            that.processErrors(error.response.data.errors);
                            that.bus.$emit(that.id+'-toastr-error', that.lang.polaris.form.form_error);
                        } else {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data);
                        }
                    });
            },

            processErrors(errors) {
                for (var name in errors) {
                    var error = errors[name];
                    if (error instanceof Array) errors[name] = error[0];
                }
                this.bus.$emit(this.id+'-errors', errors);
            }
        }

    }
</script>
